<div class="dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <h2>Outcome Rate Trends</h2>
      
      <div class="tokens-card">
        <mat-card class="tokens-mat-card">
          <mat-card-content>
            <div class="tokens-label">Period Avg Satisfaction</div>
            <div class="tokens-value">{{ averageRate | number:'1.1-1' }}%</div>
            <div style="font-size: 0.75rem; opacity: 0.8; margin-top: 4px;">
              {{ totalSatisfied }} Happy / {{ totalNotSatisfied }} Unhappy
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <div class="filter-actions" style="display: flex; gap: 8px;">
      <button mat-raised-button color="primary" (click)="fetchOutcomeRate()">
        Update
      </button>
      <button mat-stroked-button color="accent" (click)="downloadCSV()" [disabled]="!rateTable.length">
        <mat-icon>download</mat-icon> Export CSV
      </button>
    </div>
  </div>

  <mat-tab-group class="analytics-tabs">
    <mat-tab label="Trend Visualization">
      <mat-card-content style="height: 450px; padding: 20px;">
        <canvas baseChart 
          [data]="lineChartData" 
          [options]="lineChartOptions" 
          [type]="'line'">
        </canvas>
      </mat-card-content>
    </mat-tab>

    <mat-tab label="Daily Details">
      <table mat-table [dataSource]="rateTable" class="mat-elevation-z8 styled-table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let row"> {{ row.date | date:'mediumDate' }} </td>
        </ng-container>

        <ng-container matColumnDef="satisfied">
          <th mat-header-cell *matHeaderCellDef> Satisfied </th>
          <td mat-cell *matCellDef="let row"> {{ row.Satisfied }} </td>
        </ng-container>

        <ng-container matColumnDef="not_satisfied">
          <th mat-header-cell *matHeaderCellDef> Not Satisfied </th>
          <td mat-cell *matCellDef="let row"> {{ row.Not_Satisfied }} </td>
        </ng-container>

        <ng-container matColumnDef="rate">
          <th mat-header-cell *matHeaderCellDef> Satisfaction Rate </th>
          <td mat-cell *matCellDef="let row"> 
             <strong>{{ row.satisfaction_rate | number:'1.0-1' }}%</strong>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['date', 'satisfied', 'not_satisfied', 'rate']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['date', 'satisfied', 'not_satisfied', 'rate'];"></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>